<div class="bar-wrapper">
  <div class="bar-fill" [style.width.%]="progressPercentage"></div>
</div>
